import {
  Toast,
  ToastType,
} from '@eCommerce/frontend-legacy-shared-library-native';
import {Pressable, Text, View} from 'native-base';
import React, {useState} from 'react';

import OfferText from 'components/Offers/OfferDetails/OfferDetailsFormattedText';
import {OFFER_TERMS_ERROR} from 'models/Offer';

interface Props {
  padding: string;
  terms: string | undefined;
  termsError: boolean;
}

const TermsPressable = (props: Props) => {
  const {padding, terms, termsError} = props;

  const [isTermsVisible, setTermsVisible] = useState(false);
  const handleTermsPressed = () => {
    setTermsVisible(!isTermsVisible);
  };
  return !terms ? null : (
    <>
      <View minW={padding} minH={padding} />
      <Pressable
        testID="terms-button"
        onPress={handleTermsPressed}
        accessibilityLabel="Expand Terms and Conditions">
        <Text underline fontWeight="semibold">
          Terms & Conditions
        </Text>
      </Pressable>
      {isTermsVisible && termsError && (
        <>
          <View minW={padding} minH={padding} />
          <Toast
            toast={{
              type: ToastType.DANGER,
              messageContent: OFFER_TERMS_ERROR,
              hide: false,
            }}
            autoHide={false}
            onRemove={() => setTermsVisible(false)}
          />
        </>
      )}
      {isTermsVisible && !termsError && (
        <>
          <View minW={padding} minH={padding} />
          <OfferText text={terms} />
        </>
      )}
    </>
  );
};

export default TermsPressable;
